/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  Table,
} from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { callAPI } from 'lorautils/api';
import format from 'date-fns/format';
import IntlMsg from 'lorautils/intl/IntlMsg';
import SearchInput from 'loracoms/SearchInput';
import TablePager from 'loracoms/TablePager';
import Checkbox from 'loracoms/Checkbox';
import ShowIf from 'loracoms/ShowIf';
import styles from '../DeviceModal/styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onChoose: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  checkedIds: PropTypes.array,
};

const defaultProps = {
  checkedIds: [],
};

class DvcssModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      lists: [],
      reset: 0,
      status: 'idle',
      checkedIds: props.checkedIds,
      checked: [],
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChangeMark = this.handleChangeMark.bind(this);
    this.mark = '';
    this.q = null;
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, checkedIds } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
      if (showModal) {
        this.loadData();
      }
    }
    this.setState({ checkedIds });
  }

  componentWillUnmount() {
    this.loadData = null;
  }

  loadData() {
    const { appId } = this.props;
    callAPI({
      endpoint: '/lora/nodes',
      query: {
        app: appId,
        pageSize: 10,
        q: this.q,
        mark: this.mark,
      },
    }).then((data) => {
      const { list, more, mark } = data;
      this.setState({
        lists: list,
        status: 'success',
        more,
        mark,
        noData: list.length === 0,
      });
    }).catch(() => {
      this.setState({
        status: 'failure',
      });
    });
  }

  allChecked() {
    const { lists, checked } = this.state;
    let allChecked = true;
    if (lists.length) {
      lists.forEach((d) => {
        if (!_.some(checked, { id: d.id })) {
          allChecked = false;
          return false;
        }
        return null;
      });
    } else {
      allChecked = false;
    }
    return allChecked;
  }


  handleToggleCheckAll(check) {
    const { lists } = this.state;
    let { checked, checkedIds } = this.state;
    if (check) {
      checked = _.concat(lists, checked);
      const ids = _.map(checked, a => a.id);
      checkedIds = _.uniq(_.concat(checkedIds, ids));
    } else {
      _.forEach(lists, (list) => {
        checked = _.filter(checked, c => c.id !== list.id);
        checkedIds = _.filter(checkedIds, h => h !== list.id);
      });
    }
    this.setState({ checked, checkedIds });
  }

  isChecked(d) {
    const { checkedIds } = this.state;
    return _.includes(checkedIds, d.id);
  }

  toggleCheck(d) {
    let { checked, checkedIds } = this.state;
    if (this.isChecked(d)) {
      checked = _.filter(checked, a => a.id !== d.id);
      checkedIds = _.filter(checkedIds, c => c !== d.id);
    } else {
      checked.push(d);
      checkedIds.push(d.id);
    }
    this.setState({ checked, checkedIds });
  }

  handleSearch(e) {
    const search = e.target.value;
    this.setState({
      search,
      reset: new Date(),
    });
    this.mark = '';

    if (search.length > 0) {
      const s = search.replace(/[:-]/g, '');
      this.q = `or,name:*${s}*,deveui:*${s}*,devaddr:*${s}*,appIdeui:${s}*,city:*${s}*,area:*${s}*,band:*${s}*`;
      this.loadData();
    } else {
      this.q = null;
      this.loadData();
    }
  }

  handleSubmit() {
    const { onHide, onChoose } = this.props;
    const { checked, checkedIds } = this.state;
    onHide();
    if (checkedIds.length === 0) {
      return;
    }
    onChoose(checked, checkedIds);
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date() }, () => {
      this.loadData();
    });
  }

  handleChangeMark(mark) {
    this.mark = mark;
    this.loadData();
  }

  handleCancel() {
    this.mark = '';
    this.q = null;
    this.setState({ search: '', reset: new Date(), checked: [] });
    this.props.onHide();
  }

  render() {
    const {
      showModal,
      search = '',
      mark = '',
      more = false,
      reset,
      status,
      lists,
      noData = false,
    } = this.state;
    const rows = _.map(lists, item => (
      <tr key={item.id}>
        <td>
          <div className={styles.checkbox}>
            <Checkbox
              id={item.id}
              checked={this.isChecked(item)}
              onChange={() => this.toggleCheck(item)}
            />
            <label htmlFor={item.id} />
          </div>
        </td>
        <td>{item.name}</td>
        <td>{item.deveui}</td>
        <td>{format(item.createdAt, 'YYYY-MM-DD HH:mm:ss')}</td>
      </tr>
    ));
    return (
      <Modal
        show={showModal}
        bsClass="aisz-modal-light"
      >
        <Modal.Header>
          <SearchInput
            onChange={this.handleSearch}
            value={search}
            placeholder={this.intlMsg.msg('search.placeholder')}
          />
        </Modal.Header>
        <Modal.Body className="clearfix">
          <Table
            className="aisz-table-light" striped hover bordered responsive
          >
            <thead>
              <tr>
                <th>
                  <div className={styles.checkbox}>
                    <Checkbox
                      id="all"
                      checked={this.allChecked()}
                      onChange={e => this.handleToggleCheckAll(e)}
                    />
                  </div>
                </th>
                <th>{this.intlMsg.msg('addmodal.name')}</th>
                <th>{this.intlMsg.msg('addmodal.deveui')}</th>
                <th>{this.intlMsg.msg('addmodal.createdAt')}</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
          <ShowIf if={noData}>
            <div className="text-center">
              {this.intlMsg.msg('adddevice.nodata')}
            </div>
          </ShowIf>
          <div className="pull-right">
            <TablePager
              status={status}
              mark={mark}
              more={more}
              onPrev={this.handleChangeMark}
              onNext={this.handleChangeMark}
              reset={reset}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-success"
            onClick={() => this.handleSubmit()}
          >
            {this.intlMsg.msg('confirm')}
          </Button>
          <Button
            bsStyle="aisz-default"
            onClick={() => this.handleCancel()}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DvcssModal.propTypes = propTypes;
DvcssModal.defaultProps = defaultProps;

export default connect(null,
  null,
)(injectIntl(CSSModules(DvcssModal,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/DvcssModal/index.jsx